<template lang="pug">
.text-start
  .text.mt-4 Utilize o PowerShell para a execução dos comandos e instale o OpenSSL.
  .h6.mt-4 #[strong Instalar OpenSSL]
  .text.mt-4 Uma das opções é usar o OpenSSL distribuído com o pacote Git para Windows,
    |
    | disponível neste link:
    a.color--info(href='https://git-scm.com/download/win', target='_blank') https://git-scm.com/download/win
  .text.mt-4 Faça o download da versão #[strong Portable ("thumbdrive edition")] e descompacte na
    |
    | pasta desejada.
  .text.mt-4 Acrescente o caminho completo para o executável toda vez que executar o OpenSSL.
    |
    | Exemplo:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='installationPath')
        span.fw-bold $ #{ "c:\\users\\<usuario>\\git\\usr\\bin" }
        | #{ "\\openssl" } req -new
        |
        | -newkey rsa:2048 -keyout
        = ' '
        span.red-background.color--grayscale-dark cert1.key
        = ' '
        | -out
        = ' '
        span.red-background.color--grayscale-dark cert1.csr
    Icon#copy-installation-path.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.installationPath, 1)',
      @mouseleave='resetContent(1)',
      style='cursor: pointer'
    )
  .h6.mt-4 #[strong Scripts PowerShell]
  .text.mt-4 Serão necessários dois scripts, um para converter de hexadecimal para binário,
    |
    | e outro para codificar em Base64 a assinatura.
  .text.mt-4 Crie o arquivo #[span.color--info hex-to-bin.ps1] com o seguinte
    |
    | (no Bloco de Notas ou outroeditor similar):
  .code-box.mt-3
    .text $dir = (Get-Item .).FullName#[br]
      | $hex = Get-Content -Path "$dir\digitalterm_hash.hex" -Raw#[br]
      | [byte[]]$bytes = ($hex -split '(.{2})' -ne '' -replace '^', '0X')#[br]
      | [System.IO.File]::WriteAllBytes("$dir\digitalterm_hash.bin", $bytes)
  .text.mt-4 Crie o arquivo #[span.color--info base64.ps1] com o seguinte conteúdo:
  .code-box.mt-3
    .text $dir = (Get-Item .).FullName#[br]
      | $Text = Get-Content -Path "$dir\signature.bin" -Raw#[br]
      | $Bytes = [System.Text.Encoding]::Unicode.GetBytes($Text)#[br]
      | $EncodedText =[Convert]::ToBase64String($Bytes)#[br]
      | $EncodedText
  .h6.mt-4 #[strong Permissões]
  .text.mt-4 Para permitir a execução dos scripts, execute o comando e reponda Sim / Yes
    |
    | quando solicitado:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='permission')
        | $ Set-ExecutionPolicy -ExecutionPolicy Unrestricted -Scope CurrentUser
    Icon#copy-permission.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.permission, 2)',
      @mouseleave='resetContent(2)',
      style='cursor: pointer'
    )
  .code-box.mt-3
    .text Execution Policy Change#[br]
      | The execution policy helps protect you from scripts that you do not trust. Changing the
      | execution policy might expose#[br]
      | you to the security risks described in the about_Execution_Policies help topic at#[br]
      | https:/go.microsoft.com/fwlink/?LinkID=135170. Do you want to change the execution
      | policy?#[br]
      | [Y] Yes [A] Yes to All [N] No [L] No to All [S] Suspend [?] Help (default is "N"):
      span.red-background
        = ' '
        | &nbsp;Y&nbsp;

  .text.mt-4 Após a emissão do certificado, se desejar pode mudar novamente a política para não
    |
    | permitir a execução de scripts com o seguinte comando:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='changePermission')
        | $ Set-ExecutionPolicy -ExecutionPolicy Restricted -Scope CurrentUser
    Icon#copy-change-permission.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.changePermission, 3)',
      @mouseleave='resetContent(3)',
      style='cursor: pointer'
    )
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { Tooltip } from 'bootstrap'

  type TooltipType = {
    id: number
    tooltip: Tooltip
  }

  export default defineComponent({
    name: 'GenerateCSRRequestView',
    components: {
      Icon,
    },
    data() {
      return {
        tooltips: [] as TooltipType[],
      }
    },
    mounted() {
      this.tooltips.push({
        id: 1,
        tooltip: new Tooltip('#copy-installation-path', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 2,
        tooltip: new Tooltip('#copy-permission', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 3,
        tooltip: new Tooltip('#copy-change-permission', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })
    },
    methods: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async doCopy(ref: any, id: number) {
        await navigator.clipboard.writeText(ref.textContent.replace('$ ', ''))
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Código copiado!' })
      },
      resetContent(id: number) {
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Clique para copiar' })
      },
    },
  })
</script>
